
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import "./AboutUsMobile.css";
const ServiceCard = ({ title, subtitle, imageUrl, link }) => {
  return (
    <Link to={link} className="links">
      <motion.div
        className="product-card"
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        whileHover={{ scale: 1.05 }}
        whileTap={{ scale: 0.95 }}
        transition={{ duration: 0.3 }}
      >
        {/* <div className="product-card-image">
        <img src={imageUrl} alt="" />
      </div> */}
        <div className="product-card-content">
          <h2 className="product-card-title">{title}</h2>
          <p className="product-card-subtitle">{subtitle}</p>
        </div>
      </motion.div>
    </Link>
  );
};

const AboutUsMobile = () => {
  const services = [
    {
      title: "Our Vision",
      subtitle: "Know our Vision.",
      link: "/our-vision",
    },
    {
      title: "Work with Us",
      subtitle: "Discover new opportunities.",
      link: "/work-with-us",
    },
    {
      title: "Our Team",
      subtitle: "Meet our Guiding Force.",
      link: "/our-team",
    },
    {
      title: "Events",
      subtitle: "Know what's happening.",
      link: "/events",
    },

    {
      title: "Brochures",
      subtitle: "Get a read !",
      link: "/brochures",
    },
  ];
  return (
    <>
      <motion.div
        className="aboutUsMobilePage"
        initial={{ y: "-120%", opacity: 0 }}
        animate={{ opacity: 1, y: "0px" }}
        exit={{ opacity: 0, visibility: "hidden" }}
        transition={{ duration: 0.4 }}
      >
        {services.map((slider, index) => (
          <ServiceCard
            key={index}
            title={slider.title}
            subtitle={slider.subtitle}
            imageUrl={slider.bgImg}
            link={slider.link}
          />
        ))}
      </motion.div>
    </>
  );
};

export default AboutUsMobile;
